import { render } from "./BrowserLogs.vue?vue&type=template&id=7b832b7f&scoped=true"
import script from "./BrowserLogs.vue?vue&type=script&lang=js"
export * from "./BrowserLogs.vue?vue&type=script&lang=js"

import "./BrowserLogs.vue?vue&type=style&index=0&id=7b832b7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b832b7f"]])

export default __exports__